import React from 'react';
import "./imageCards.css"
import {checkReplaceUrl} from '../../utils'
import CustomImage from '../Common/CustomImage';
import { useTranslation } from 'react-i18next';

const ImageCards = (props) => {
    const cardData = props?.data;
    const cardTitle = props?.title;
    const pageType = props?.pageType;
    const { t } = useTranslation();

    // const formatDateToLocal = (utcDateString) => {
    //     const options = { year: "numeric", month: "short", day: "2-digit" };
    //     return new Date(utcDateString).toDateString(undefined, options);
    // };
    const formatDateToLocal = (utcDateString) => {
    const date = new Date(utcDateString);
    const year = date.getFullYear();
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun","Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = monthNames[date.getMonth()];
    const day = String(date.getDate()).padStart(2, '0');
        return `${day} ${month}  ${year}`;
    };

    return (
        <React.Fragment>
            {props.isApiLoading && (
                <div className="sd-grid lg:sd-grid-cols-3 sd-grid-cols-1 sd-gap-[16px] lg:sd-grid-rows-auto ">
                    {[...Array(15).keys()].map((item, index) => (
                        <div className="sd-flex-col sd-pb-[88px] sd-h-full sd-justify-between sd-flex" key={index}>
                            <div className="sd-items-center sd-justify-center sd-w-full  sd-mx-auto">
                                <div className="sd-skeleton sd-w-full" style={{ height: "362px" }}></div>
                            </div>
                            <div className=" sd-items-center sd-justify-between sd-w-full sd-my-[9px] sd-w-1/4">
                                <div className="sd-skeleton sd-h-[24px] " style={{ width: "30%" }}></div>

                            </div>
                            <div className="sd-items-center sd-justify-between sd-w-full sd-my-[9px]">
                                <div className="sd-skeleton sd-h-[16px] " style={{ width: "75%" }}></div>
                            </div>
                            <div className="sd-bg-gray-300 sd-rounded-full sd-w-fit sd-content  sd-py-2 sd-px-4 sd-flex sd-items-center sd-justify-end sd-animate-pulse  hover:sd-bg-black sd-mt-[2px]">
                                <h5 className="sd-text-black sd-px-2 hover:sd-text-white ">
                                </h5>
                            </div>
                        </div>

                    ))}
                </div>
            )}
            {!(props?.isApiLoading) && props?.data?.length > 0 && (
                <div className="sd-grid lg:sd-grid-cols-3 sd-grid-cols-1 sd-gap-[16px] lg:sd-grid-rows-auto ">
                    {props?.data.map((cardData, index) => (
                        <div key={"imgCard"+index} className="sd-flex-col sd-pb-[88px] sd-h-full sd-justify-between sd-flex">


                            <div className="sd-items-center sd-justify-center sd-w-full  sd-mx-auto">
                                <CustomImage
                                    src={
                                        checkReplaceUrl(cardData?.primaryImage)
                                    }
                                    alt="cardData 1"
                                    className="sd-object-cover sd-h-[362px] sd-w-full"
                                />
                                <h3 className="sd-titleText sd-mt-3 sd-mb-1">{cardData?.documentType}</h3>
                                {cardData?.title && (
                                        <p className="sd-text-[23px] lg:sd-col-span-2 sd-col-span-8 sd-mb-0">
                                            {/* {cardData?.title} */}
                                            {cardData?.title[0].replace(/\s*\|\s*Sandisk$/i, "")}
                                        </p>
                                )}
                                {cardData?.documentTypeDate && (
                                        <h4 className="sd-text-black sd-mt-2 sd-mb-1">
                                            {"[" + formatDateToLocal(cardData?.documentTypeDate) + "]"}
                                        </h4>
                                    )}
                                <div className=''>

                                    {cardData?.description && (
                                        <p className="sd-mb-4">
                                            {(pageType?.toLowerCase() === "media+kits" || pageType?.toLowerCase() === "media kits")
                                                ? (Array.isArray(cardData?.description) ? cardData?.description[0] : cardData?.description)
                                                : (Array.isArray(cardData?.description)
                                                    ? cardData?.description[0].length > 100 ? cardData?.description[0].slice(0, 99) + "..." : cardData?.description[0]
                                                    : cardData?.description.length > 100 ? cardData?.description.slice(0, 99) + "..." : cardData?.description)}
                                        </p>
                                    )}
                                    {cardData?.content && (
                                        <div className="" dangerouslySetInnerHTML={{
                                            __html: cardData.content.length > 100
                                                ? cardData.content.slice(0, 100) + "..."
                                                : cardData.content
                                        }} />
                                    )}

                                    {cardData?.eventStartDate && cardData?.eventEndDate && (
                                        <p className="sd-mb-4">
                                            {"[" + formatDateToLocal(cardData?.eventStartDate[0]) +
                                                " - " +
                                                formatDateToLocal(cardData?.eventEndDate[0])
                                                + "]"
                                            }
                                        </p>
                                    )}

                                </div>


                            </div>

                            <a 
                                // href={cardData.url}
                                href={checkReplaceUrl(cardData?.url)}
                                className="sd-sm-btn-grey sd-cursor-pointer"
                            >
                                <span className='sd-font-nb'> {cardData?.documentType == 'Media Kits' ? t('download') : 'Read More'}</span>
                            </a>

                            {/* {JSON.stringify(cardData)} */}
                        </div>

                    ))}
                </div>
            )}

        </React.Fragment>

    )

};

export default ImageCards;